var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-align-items-top gl-flex gl-break-all gl-font-monospace gl-text-sm",class:[_vm.padding, _vm.borderClass]},[(_vm.icon)?_c('div',{staticClass:"gl-mr-4 gl-w-5"},[_c('gl-icon',{attrs:{"name":_vm.icon}})],1):_vm._e(),_vm._v(" "),_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }